/*!function(){"use strict";const e="[data-video-template]",t="is-loading",i="data-video-id";customElements.get("video-background")||customElements.define("video-background",class extends HTMLElement{constructor(){super()}connectedCallback(){this.videoId=this.getAttribute(i),this.videoTemplate=this.querySelector(e),this.video=null,this.powerSaverVideoPlay=this.powerSaverVideoPlay.bind(this),this.videoId&&this.renderVideo()}powerSaverVideoPlay(){this.video?.play()}renderVideo(){this.videoTemplateObserver=new IntersectionObserver(((e,i)=>{e.forEach((e=>{if(e.isIntersecting){const o=this.videoTemplate.innerHTML;this.innerHTML=o,this.classList.remove(t),this.video=this.querySelector("video"),this.observeVideoPlayToggle(),this.video.play().then((()=>{})).catch((()=>{document.addEventListener("click",this.powerSaverVideoPlay,{passive:!0,bubbles:!0,once:!0}),document.addEventListener("touchstart",this.powerSaverVideoPlay,{passive:!0,bubbles:!0,once:!0})})),i.unobserve(e.target)}}))}),{root:null,rootMargin:"300px",threshold:[0,.1,.25,.5,.75,1]}),this.videoTemplateObserver.observe(this)}observeVideoPlayToggle(){if(!this.video)return;this.videoPlayObserver=new IntersectionObserver((e=>{e.forEach((e=>{const t=e.isIntersecting;if(t&&"function"==typeof this.video.play){const e=this.video.play();void 0!==e&&e.then((e=>{})).catch((e=>{}))}t||"function"!=typeof this.video.pause||this.video.pause()}))}),{rootMargin:"0px",threshold:[0,1]}),this.videoPlayObserver.observe(this.video)}disconnectedCallback(){this.videoTemplateObserver&&this.videoTemplateObserver.disconnect(),this.videoPlayObserver&&this.videoPlayObserver.disconnect(),this.videoId&&(document.removeEventListener("click",this.powerSaverVideoPlay),document.removeEventListener("touchstart",this.powerSaverVideoPlay))}})}();
*/

!function () {
  "use strict";
  const TEMPLATE_SELECTOR = "[data-video-template]";
  const LOADING_CLASS = "is-loading";
  const VIDEO_ID_ATTR = "data-video-id";

  customElements.get("video-background") ||
    customElements.define(
      "video-background",
      class extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.videoId = this.getAttribute(VIDEO_ID_ATTR);
          this.videoTemplate = this.querySelector(TEMPLATE_SELECTOR);
          this.video = null;
          this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);

          if (!this.videoId) return;

          // Ne commence à observer qu'une fois que la page a fini de charger
          if (document.readyState === "complete") {
            this.armObserver();
          } else {
            window.addEventListener("load", () => this.armObserver(), { once: true });
          }
        }

        armObserver() {
          // Respecte les utilisateurs en mode "économie de données" / connexion lente
          const saveData = navigator.connection?.saveData;
          const slowConnection = ["slow-2g", "2g"].includes(navigator.connection?.effectiveType);
          if (saveData || slowConnection) return; // reste sur le poster, pas de vidéo

          this.renderVideo();
        }

        powerSaverVideoPlay() {
          this.video?.play();
        }

        renderVideo() {
          this.videoTemplateObserver = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const html = this.videoTemplate.innerHTML;
                  this.innerHTML = html;
                  this.classList.remove(LOADING_CLASS);
                  this.video = this.querySelector("video");
                  this.observeVideoPlayToggle();
                  this.video
                    .play()
                    .then(() => {})
                    .catch(() => {
                      document.addEventListener("click", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
                      document.addEventListener("touchstart", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
                    });
                  obs.unobserve(entry.target);
                }
              });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
          );
          this.videoTemplateObserver.observe(this);
        }

        observeVideoPlayToggle() {
          if (!this.video) return;
          this.videoPlayObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible = entry.isIntersecting;
                if (visible && typeof this.video.play === "function") {
                  const p = this.video.play();
                  if (p !== undefined) p.then(() => {}).catch(() => {});
                }
                if (!visible && typeof this.video.pause === "function") this.video.pause();
              });
            },
            { rootMargin: "0px", threshold: [0, 1] }
          );
          this.videoPlayObserver.observe(this.video);
        }

        disconnectedCallback() {
          this.videoTemplateObserver?.disconnect();
          this.videoPlayObserver?.disconnect();
          if (this.videoId) {
            document.removeEventListener("click", this.powerSaverVideoPlay);
            document.removeEventListener("touchstart", this.powerSaverVideoPlay);
          }
        }
      }
    );
}();